<div class="checkbox-tree">
  <ng-container *ngFor="let node of data">
    <div
      class="tree-node"
      [ngStyle]="{ 'padding-left': getNodePadding(level) }"
    >
      <hyperkit-checkbox
        [checked]="node.checked || false"
        [indeterminate]="node.indeterminate || false"
        [label]="node.label"
        [disabled]="node.disabled || false"
        (click)="onNodeClick(node)"
      ></hyperkit-checkbox>

      <hyperkit-checkbox-tree
        *ngIf="node.children?.length"
        [data]="node.children ?? []" 
        [level]="level + 1"
        CheckboxTreeSelection
        (nodeChange)="onChildNodeChange($event, node)"
      ></hyperkit-checkbox-tree>
    </div>
  </ng-container>
</div>
